import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/core/services/navigation/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  home: MenuItem;
  dir:string;
  paymentMethodSelected: any = null;
  constructor(
    public breadSer:BreadcrumbService,private router:Router,private translate:TranslateService) { 
  }
  
  ngOnInit() {
    this.home = {icon: 'pi icon-requests icon-sm', routerLink: ['/schedule']};
    this.router.navigate(['newrequest/category']);
    let currentLnaguage =  localStorage.getItem('lang');
    if(currentLnaguage == null){
        this.dir = "ltr"; 
    }
    else
    {
      if(currentLnaguage == 'ar'){
        this.dir = "rtl"; 
      }
      else{
       this.dir = "ltr"; 
      }
    }
  }

  // async confirmPayment(){
  //   let model :ICallQueue  =  
  //   {
  //     Id:0,
  //     AppointmentDate:this.dynamicSelected.date.toString(),
  //     ClinicID:this.dynamicSelected.item.clinicId,
  //     MobileDoctorPath: this.categorySelected.mobileDoctorPath,
  //     PortalPaymentOption:this.paymentMethodSelected,
  //     ProviderID:this.dynamicSelected.item.providerId,
  //     ServiceId:this.dynamicSelected.item.serviceId,
  //     PatientId: +localStorage.getItem('PatientId'),
  //     AppointmentDateNote:"",
  //     Area:this.dynamicSelected.address,
  //     AppointmentTime:this.dynamicSelected.time,
  //     CreationDate:new Date().toString(),
  //     AppointmentTimeNote:"",
  //     Comment:this.dynamicSelected.comment,
  //     MultiAttachment:false,
  //     ImagePath:"",
  //     IsEmergency:false,
  //     IsPayment:true,
  //     PatientName:"",
  //     RequestType:0,
  //     TimeZoneOffset:0
  //   };
  //   if(this.uploadedFiles.length > 0)
  //   {
  //     var imageData:any = await this.getImageData(this.uploadedFiles[0]);
  //     model.ImagePath = imageData.data;
  //     model.MultiAttachment = this.uploadedFiles.length > 1 ? true : false;
  //   }
  //   var url = `/api/Queue/AddToQueue`;
  //   this.helperService.postRequest(url,true,model).subscribe(response =>
  //   {
  //     if(response.Success)
  //     {
  //     }
  //     else
  //     {
  //       this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
  //     }   
  //     this.isLoading = false;
  //   },
  //   error=>{
  //       this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
  //       this.isLoading = false;
  //   })
  // }
  
}
